export default "__VITE_ASSET__CE28Z$3L__"